<template>
	<div class="infor fl">
		<AllHeader :label="lable" />
		<Allylist/>
	</div>
</template>

<script>
	import Allylist from "./Modal/Allylist";
	import AllHeader from "@/components/Modal/AllHeader";
	export default {
		name: "apply",
		components: {
			Allylist,
			AllHeader
		},
		data() {
			return {
				// step: 0,
				lable: '',
			}
		},
		mounted() {
			this.lable = this.$route.query.name;
		},
		methods: {
			// closepop(step) {
			// 	this.step = step
			// }

		}
	}
</script>
<style scoped lang="less">

</style>
